// ** Redux Imports
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  submitAdminOathAffidavit,
  submitSupplementaryAffidavit,
  getAdminOathAffidavitDocumentList,
  getAdminOathAffidavitInformation,
  getAdminOathAffidavitPdf,
  requestAdminOathAffidavitTimeExtension,
  CalculateFees,
  ProceedToPay,
  CheckMainSubmissionDone,
  PdfValidate,
  PdfValidate2
} from "@api";

export const submitAdminOathAffidavitDocuments = createAsyncThunk(
  "adminoathaffidavit/submitAdminOathAffidavitDocuments",
  async (args) => {
    const response = await submitAdminOathAffidavit(args);
    return response.data;
  }
);

export const submitSupplementaryAffidavitDocuments = createAsyncThunk(
  "adminoathaffidavit/submitSupplementaryAffidavitDocuments",
  async (args) => {
    const response = await submitSupplementaryAffidavit(args);
    return response.data;
  }
);

export const getDocuments = createAsyncThunk(
  "adminoathaffidavit/getAdminOathAffidavitDocuments",
  async (args) => {
    const response = await getAdminOathAffidavitDocumentList({ args });
    return response.data;
  }
);

export const getInformation = createAsyncThunk(
  "adminoathaffidavit/getInformation",
  async (args) => {
    const response = await getAdminOathAffidavitInformation({ args });
    return response.data;
  }
);

export const getGeneratedPdf = createAsyncThunk(
  "adminoathaffidavit/getGeneratedPdf",
  async (args) => {
    const response = await getAdminOathAffidavitPdf({ fileId: args });
    return response.data;
  }
);

export const requestTimeExtension = createAsyncThunk(
  "adminoathaffidavit/requestAdminOathAffidavitTimeExtension",
  async (args) => {
    const response = await requestAdminOathAffidavitTimeExtension({
      reason: args,
    });
    return response.data;
  }
);

export const calculateFeesAdminOathAffidavit = createAsyncThunk(
  "payment/calculate_fees_",
  async (args) => {
    const response = await CalculateFees(args);
    return response.data;
  }
);

export const proceedToPayAdminOathAffidavit = createAsyncThunk(
  "payment/proceed_to_pay",
  async (args) => {
    const response = await ProceedToPay(args);
    return response.data;
  }
);

export const checkMainSubmissionDoneAdminOathAffidavit = createAsyncThunk(
  "payment/check_mainsubmission_done_adminoathaffidavit",
  async (args) => {
    const response = await CheckMainSubmissionDone(args);
    return response.data;
  }
);

export const pdfValidate = createAsyncThunk(
  "common/pdf_validation",
  async (args) => {
    const response = await PdfValidate(args);
    return response.data;
  }
);

export const pdfValidate2 = createAsyncThunk(
  "common/pdf_validation2",
  async (args) => {
    const response = await PdfValidate2(args);
    return response.data;
  }
);

export const adminOathAffidavitSlice = createSlice({
  name: "adminoathaffidavit",
  initialState: {
    session: "",
    documentList: [],
    showTimeExtension: false,
    showPaymentModal: false,
    totalPayable: (0.0).toFixed(2),
    submissionGroupid: "",
    showAdminOathUploadZone: true,
    showSupportingAffidavitUploadZone: true,
    showSupplementaryAffidavitUploadZone: true,
    templates: [],
    elitCaseNo: "",
    requestDate: "",
    timeExtensionStatus: "",
    timeExtensionReason: "",
    submissionDate: "",
    newSubmissionDate: "",
    isLateSoa: false,
    probateAcceptedDate: "",
    targetNewSubmissionDate: "",
    //isConfirm: false,
    allowSupplementaryAffidavit: false,
    adminOathStatus: false,
    supportingAffidavitStatus: false,
    supplementaryAffidavitStatus: false,
    showPendingDocumentNotification: false,
    pendingDocumentNotificationMessage: "",
    enablePay: false,
    enableLoe: false,
    nextStepMessage: "",
    hearingDateStatus: false,
    hearingDate: "",
    feeFor: "AdminOathAffidavit",
    isPaymentProcessing: false,
    disabledToggleAffidavitDueExecution: false,
    affidavitDueExecutionStatus: "",
    isRequiredAffidavitDueExecution: false,
    disabledDropZoneAffidavitDueExecution: false,
  },
  reducers: {
    updateShowTimeExtension(state, action) {
      state.showTimeExtension = action.payload;
    },
    updateShowPaymentModal(state, action) {
      state.showPaymentModal = action.payload;
    },
    updateIsRequiredAffidavitDueExecution(state, action) {
      state.isRequiredAffidavitDueExecution = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDocuments.fulfilled, (state, action) => {
        if (action.payload instanceof Array) {
          state.documentList = action.payload;
        }
      })
      .addCase(getInformation.fulfilled, (state, action) => {
        if (action.payload.templateList instanceof Array) {
          state.templates = action.payload.templateList;
        }
        state.elitCaseNo = action.payload.elitCaseNo;
        state.requestDate = action.payload.requestDate;
        state.timeExtensionStatus = action.payload.timeExtensionStatus;
        state.timeExtensionReason = action.payload.timeExtensionReason;
        state.submissionDate = action.payload.submissionDate;
        //state.newSubmissionDate = action.payload.newSubmissionDate;
        state.isLateSoa = action.payload.isLateSOA;
        state.probateAcceptedDate =
          action.payload.probateApplicationAcceptedDate;
        state.targetNewSubmissionDate = action.payload.targetNewSubmissionDate;
        state.allowSupplementaryAffidavit =
          action.payload.allowSupplementaryAffidavit;

        //state.isConfirm = action.payload.isConfirm;
        state.showAdminOathUploadZone = action.payload.showAdminOathUploadZone;
        state.showSupportingAffidavitUploadZone =
          action.payload.showSupportingAffidavitUploadZone;
        state.showSupplementaryAffidavitUploadZone =
          action.payload.showSupplementaryAffidavitUploadZone;
        state.adminOathStatus = action.payload.adminOathStatus;
        state.supportingAffidavitStatus =
          action.payload.supportingAffidavitStatus;
        state.supplementaryAffidavitStatus =
          action.payload.supplementaryAffidavitStatus;
        state.showPendingDocumentNotification =
          action.payload.showPendingDocumentNotification;
        state.pendingDocumentNotificationMessage =
          action.payload.pendingDocumentNotificationMessage;
        state.enablePay = action.payload.enablePay;
        state.enableLoe = action.payload.enableLoe;
        state.nextStepMessage = action.payload.nextStepMessage;
        state.hearingDateStatus = action.payload.hearingDateStatus;
        state.hearingDate = action.payload.hearingDate;
        state.feeFor = action.payload.feeFor;

        // AffidavitDueExecutionSection
        state.disabledToggleAffidavitDueExecution = action.payload.disabledToggleAffidavitDueExecution;
        state.affidavitDueExecutionStatus = action.payload.affidavitDueExecutionStatus;
        state.isRequiredAffidavitDueExecution = action.payload.isRequiredAffidavitDueExecution;
        state.disabledDropZoneAffidavitDueExecution = action.payload.disabledDropZoneAffidavitDueExecution;

      })
      .addCase(calculateFeesAdminOathAffidavit.fulfilled, (state, action) => {
        state.totalPayable = action.payload.TotalPayable.toFixed(2);
        state.submissionGroupid = action.payload.SubmissionGroupId;
        state.showPaymentModal = true;
      })
      .addCase(checkMainSubmissionDoneAdminOathAffidavit.fulfilled, (state, action) => {
        state.isPaymentProcessing = action.payload.isPaymentProcessing;
      });
  },
});

export const adminOathAffidavitActions = adminOathAffidavitSlice.actions;
export default adminOathAffidavitSlice.reducer;
